/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Care_Log_Select_NoneInputs */

const vi_care_log_select_none = /** @type {(inputs: Care_Log_Select_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chưa chọn`)
};

/**

* @param {Care_Log_Select_NoneInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const care_log_select_none = /** @type {((inputs?: Care_Log_Select_NoneInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Care_Log_Select_NoneInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_care_log_select_none(inputs)
});